"use strict";

import { toBool } from "../../lib/utils.js";
import { Basic } from "../basic.ts";
import i18next from "i18next";
import styles from './frame.css'

/**
 * @class MSFrame
 * @extends Basic
 * @classdesc Контейнер
 * */
export class MSFrame extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat(["datasource", "sizetocontent", "contentscalingoff"]);
    }

    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });
        
        if (this.id == (window.activeMonitorTemplateId ? $WinDefs.constructor.mainFrame[window.activeMonitorTemplateId] : Object.values($WinDefs.constructor.mainFrame)[0])) {
            this._pushState = true;
        }
        this.style.userSelect = "none";
        shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>
            <div class="content">
                <slot></slot>
            </div>
        `;

        this.shadowRoot.querySelector(".content").style.overflow = "visible";
        this.setInitialBordersValues();

        if (window.ipc) {
            try {
                this.pdfViewer = window.ipc.get().sendSync("server", "getPdf");
            } catch (e) { }
        }
        this._sizetocontent = 1;
        this._contentscalingoff = true;
        this.firstRun = true;
        this.frameHistory = [];
        //this.historyIdx = 0;

        if ($pm.hasPermissions) {
            this.afterSwitch = this.afterSwitch.bind(this);
            window.addEventListener("ms_message", this.afterSwitch);
        }
        this._scaleFactor = 1;  
        this._zoomFrameContent();
        if (this.hasAttribute("overflow-hidden")) { // Если frame находится внутри карты, то у него должен быть overflow: hidden;
            this.style.overflow = "hidden";
        }
    }

    _zoomFrameContent() {
        this._isHovered = false;
        this._onMouseEnter = () => {
            this._isHovered = true;
            window.addEventListener("keydown", this._onKeyDown, true);
        };

        this._onMouseLeave = () => {
            this._isHovered = false;
            window.removeEventListener("keydown", this._onKeyDown, true);
        };

        this._onWheel = (event) => {
            if (this._contentscalingoff || !this._isHovered) return;
            event.stopPropagation();

            if (event.ctrlKey) {
                event.preventDefault();
                this._scaleFactor += event.deltaY < 0 ? 0.1 : -0.1;
                this._scaleFactor = Math.max(0.1, Math.min(this._scaleFactor, 3));
                this._applyContentScale();
                return;
            }

            if (event.shiftKey && this._sizetocontent !== window._enums.SizeToContentType.Crop) {
                event.preventDefault();
                this.scrollLeft += event.deltaX + event.deltaY;
            }
        };

        this.addEventListener('mouseenter', this._onMouseEnter);
        this.addEventListener('mouseleave', this._onMouseLeave);
        this.addEventListener('wheel', this._onWheel , {passive: false})


        this._onKeyDown = (event) => {
            if (this._contentscalingoff || !this._isHovered) return;

            const rootWin = this.closest("ms-window");
            if (rootWin === document.body.firstElementChild) return;

            event.stopPropagation();

            let localScale = this._scaleFactor;

            if (
                event.ctrlKey &&
                (event.key === "=" || event.key === "+" || event.which === 61 || event.which === 107)
            ) {
                localScale += 0.1;
            } else if (
                event.ctrlKey &&
                (event.key === "-" || event.which === 173 || event.which === 109 || event.which === 189)
            ) {
                localScale = Math.max(0.1, localScale - 0.1);
            }
            
            localScale = Math.min(3,Math.max(0.1, localScale))

            if (
                event.ctrlKey &&
                (event.key === "=" || event.key === "+" || event.key === "-" ||
                    event.which === 61 || event.which === 107 ||
                    event.which === 173 || event.which === 109 || event.which === 189)
            ) {
                this._scaleFactor = +localScale.toFixed(1);
                this._applyContentScale();
                event.preventDefault();
            }
        };
    }

    get contentscalingoff() {
         return this._contentscalingoff;
    }

    set contentscalingoff(value) {
        this._contentscalingoff = this._toBool(value);
    }

    _applyContentScale() {
        if (this._sizetocontent === window._enums.SizeToContentType.Scroll) {
            this._updateScrollOverflow();
            return;
        }
        const content = this.shadowRoot.querySelector(".content");
        if (content) {
            content.style.zoom = "";
            content.style.transformOrigin = "0 0";
            content.style.transform = this._scaleFactor === 1 ? "" : `scale(${this._scaleFactor})`;
        }
        if (this._scaleFactor > 1 && (this._sizetocontent === 1 || this._sizetocontent === 0)) {
            this.style.overflow = "auto";
        } else {
            this.style.overflow = "hidden";
        }
    }

    _updateScrollOverflow() {
        if (!this._msWin) return;
        const content = this.shadowRoot.querySelector(".content");
        const s = this._scaleFactor;
        const w = +this._msWin.width * s;
        const h = +this._msWin.height * s;
        if (content) {
            content.style.zoom = "";
            content.style.transform = "";
            content.style.overflow = "hidden";
            content.style.width = this._setValueUnit(w);
            content.style.height = this._setValueUnit(h);
        }
        this._msWin.style.transformOrigin = "0 0";
        this._msWin.style.transform = s === 1 ? "" : `scale(${s})`;
        this.style.overflow = w > this.clientWidth + 1 || h > this.clientHeight + 1 ? "auto" : "hidden";
        if (this.style.overflow === "hidden") {
            this.scrollLeft = 0;
            this.scrollTop = 0;
        }
    }

    afterSwitch(message) {
        const data = message.data;
        switch (data.event) {
            case "afterswitch":
                const curWin = this.firstChild?.id;
                if(this.firstChild) {
                   this.firstChild.isvisible = curWin !== undefined && $pm.checkOpenWindowRights(curWin) ? true : false;
                }
                break;
        }
    }

    setInitialBordersValues() {
        this.style.boxSizing = "border-box";
        this.style.borderWidth = "1px";
        this.style.borderStyle = "solid";
        this.style.borderColor = this.tryToGetUserColor("GRAY");
    }

    set backgroundcolor(value) {
        super.backgroundcolor = value;
        this.updateZ();
    }

    get datasource() {
        return this._datasource;
    }
    set datasource(value) {
        if (this.getStoredWindowState()) {
            return;
        }
        this.setDs(value, false, () => {
            this.updateZ();
        });
    }

    get borderthickness() {
        return this._borderthickness;
    }

    set borderthickness(value) {
        value = parseInt(value, 10);
        if (isNaN(value) || value < 0) {
            return;
        }
        this._borderthickness = value;
        this.style.borderWidth = value === 0 ? "0" : this._setValueUnit(value);
    }

    get bordercolor() {
        return this.style.borderColor;
    }

    set bordercolor(value) {
        this.style.borderColor = this.tryToGetUserColor(value);
    }

    get borderstyle() {
        return this._borderstyle;
    }

    set borderstyle(value) {
        this._borderstyle = value;
        this.style.borderStyle = this.getBorderStyle(
            window._enums.BorderStyleType[value]
        );
    }

    get width() {
        return super.width;
    }
    set width(val) {
        super.width = val;
        if (this.isPopupIframe) {
            this.style.maxWidth = this._setValueUnit(+val);
            this.style.width = "100%";
        }
        if (this._sizetocontent === window._enums.SizeToContentType.SetSize && this._msWin) {
            this._calcScale();
        } else if (this._sizetocontent === window._enums.SizeToContentType.Scroll && this._msWin) {
            this._updateScrollOverflow();
        }
    }

    get height() {
        return super.height;
    }
    set height(val) {
        super.height = val;
        if (this.isPopupIframe) {
            this.style.maxHeight = this._setValueUnit(+val);
            this.style.height = "100%";
        }
        if (this._sizetocontent === window._enums.SizeToContentType.SetSize && this._msWin) {
            this._calcScale();
        } else if (this._sizetocontent === window._enums.SizeToContentType.Scroll && this._msWin) {
            this._updateScrollOverflow();
        }
    }

    /**
     * Z-порядок
     * @type {number}
     */
    get z() {
        return this._z ?? 0;
    }
    set z(value) {
        this._z = value;
        this.updateZ();
    }

    updateZ() {
        if (!this._msWin && !super.backgroundcolor) {
            super.z = 0;
            return;
        }

        super.z = this.z;
    }

    updateZIndex(value /*:Number*/) {
        if (value > this.contentMaxZIndex) this.contentMaxZIndex = value;
        if (this._maskElement) {
            this._maskElement.style.zIndex = this.contentMaxZIndex + 1;
        }
        this.style.setProperty("--zIndex", this.contentMaxZIndex);
    }

    setDs(value, historyAction, callback) {
        if (this.firstChild && this.firstChild.id == value) {
            if (!this._msWin) this._msWin = this.firstChild;
            this._calcSize();
            callback?.();
            return;
        }
        if (value) {
            //если это не переход по истории (а открытие адреса командой)
            if (!historyAction) {
                if (this.historyIdx == undefined) {
                    this.historyIdx = 0;
                } else {
                    this.historyIdx++;
                    this.frameHistory = this.frameHistory.slice(
                        0,
                        this.historyIdx
                    );
                }
                this.frameHistory.push({ Addr: value });
            }

            this._clearWin();
            this._datasource = value;
            if (this.isAbsoluteURL(value) || this._hasPdfExtension(value) || this._hasHtmlExtension(value)) {
                const credentialedUrlRegex = /^https?:\/\/[^@]+:?[^@]*@/;
                if (credentialedUrlRegex.test(value)) {
                    this.loadIframeWithAuth(value, credentialedUrlRegex, callback);
                    return;
                }
                this.innerHTML = this.createIframe(value);
            } else {
                const winObj = this.createWinObj(value);
                if (winObj) { // todo: а разве возможно такое, что его не будет? тогда что будет вставляться в `this._msWin = this.firstChild` ?
                    this.openWindow(winObj, false, false, true)
                    if ($pm.hasPermissions && !$pm.checkOpenWindowRights(winObj.id)) {
                        this._msWin.isvisible = false
                    }
                    this._calcSize();
                }
            }
            this._msWin = this.firstChild;
            callback?.();
        }
    }

    loadIframeWithAuth(url, credentialedUrlRegex, callback) {
        const [_, username, password] = url.match(/\/\/([^:@]+):?([^@]*)@/);
        const authHeader = 'Basic ' + btoa(`${username}:${password}`);
        const protocol = url.match(/^https?:\/\//)[0];
        const cleanUrl = url.replace(credentialedUrlRegex, protocol);
        fetch(cleanUrl, {
            method: 'GET',
            headers: {
                'Authorization': authHeader
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Не удалось загрузить HTML по адресу ${newUrl}`);
                }
                return response.text();
            })
            .then(html => {
                this.innerHTML = html;
                this._msWin = this.firstChild;
                callback?.();
            })
            .catch(error => {
                console.error(error.message);
            })
    }

    createIframe(value) {
        if (this._hasPdfExtension(value) && this.pdfViewer) {
            const platform = window.navigator?.userAgentData?.platform || window.navigator.platform;
            const clientPrinter = window.clientPrinter && /Linux/.test(platform);
            if (window.ipc && clientPrinter && !window.hasMessageListener) {
                // datasource может прийти новый, либо на странице может быть несколько контролов frame, отображающих pdf-файл.
                // Поскольку в каждом iframe будет вызываться datasource,
                // то нужна проверка, чтобы слушатель события "message" для глобального объекта "window" добавился бы только 1 раз.
                // В противном случае, если на странице есть, например, 3 содержащих pdf-файла iframe,
                // то при вызове печати в одном из них, печать будет вызываться трижды.
                window.hasMessageListener = true;
                window.addEventListener("message", (event) => {
                    const { type } = event.data
                    if (type === 'print') {
                        // при обновлении frame ссылка на файл тоже может меняться,
                        // а поскольку событие прослушки "message" вешается только 1 раз,
                        // путь до файла нужно вычислять при каждом вызове события печати
                        const isAbsoluteURL = this._datasource.startsWith('//');
                        const fileUrl = isAbsoluteURL
                            ? `${decodeURIComponent(this._datasource)}`
                            : `${window.location.origin}/${decodeURIComponent(this._datasource)}`;
                        window.ipc.get().send("server", "print", {
                            fileUrl
                        });
                    }
                });
            }

            const fileUrl = this.isAbsoluteURL(value)
                ? `${decodeURIComponent(this._datasource)}`
                : `${window.location.origin}/${decodeURIComponent(this._datasource)}`;
            const url = `file://${this.pdfViewer}?file=${fileUrl}&clientPrinter=${+!!clientPrinter}`;
            return `<iframe src="${url}" style="width:100%;height:100%;"></iframe>`;
        }
        return `<iframe src="${this._datasource}" style="width:100%;height:100%;"></iframe>`;
    }

    isAbsoluteURL(url) {
        return url.startsWith("http") || url.startsWith('//');
    }

    createWinObj(value) {
        if (!value.toString().includes(".")) {
            return $WinDefs.winDef[value];
        }
        const winId = $pr.getWindowIdByPath(value);
        let winObj = winId ? $WinDefs.winDef[winId] : null;
        if (winObj && winObj.objectid === "0") {
            winObj = structuredClone(winObj);
            const { objectid, outerpath } = $pr.getObjectIdByPath(value);
            winObj.objectid = objectid;
            winObj.outerpath = outerpath;
        }
        return winObj;
    }
    

    get sizetocontent() {
        return this._sizetocontent;
    }
    set sizetocontent(value) {
        this._sizetocontent = window._enums.SizeToContentType[value];
        this._calcSize();
    }

    get isvisible() {
        return this._showElement;
    }
    set isvisible(value) {
        this._showElement = value;
        const isShow =
            (this.opacity === "" || this._toBool(this.opacity)) &&
            this._toBool(value);
        this.style.display = isShow ? "" : "none";
    }

    _calcSize() {
        if (!this._msWin) return;
        switch (this._sizetocontent) {
            case window._enums.SizeToContentType.RealSize:
                this._msWin.style.transform = ``;
                this._msWin.style.transformOrigin = "";
                this._backWidth = this._width;
                this._backHeight = this._height;
                this._width = this._msWin.width;
                this._height = this._msWin.height;
                this.style.width = this._setValueUnit(this._width);
                this.style.height = this._setValueUnit(this._height);
                this.style.overflow = "hidden";
                break;
            case window._enums.SizeToContentType.SetSize:
                this.style.overflow = "hidden";
                this._width = this._backWidth ? this._backWidth : this._width;
                this._height = this._backHeight
                    ? this._backHeight
                    : this._height;
                this.style.width = this._setValueUnit(this._width);
                this.style.height = this._setValueUnit(this._height);
                this._calcScale();
                break;
            case window._enums.SizeToContentType.Crop:
                this._msWin.style.transform = ``;
                this._msWin.style.transformOrigin = "";
                this.style.overflow = "hidden";
                this._width = this._backWidth ? this._backWidth : this._width;
                this._height = this._backHeight
                    ? this._backHeight
                    : this._height;
                this.style.width = this._setValueUnit(this._width);
                this.style.height = this._setValueUnit(this._height);
                break;
            case window._enums.SizeToContentType.Scroll:
                this._msWin.style.transform = ``;
                this._msWin.style.transformOrigin = "";
                this._width = this._backWidth ? this._backWidth : this._width;
                this._height = this._backHeight
                    ? this._backHeight
                    : this._height;
                this.style.width = this._setValueUnit(this._width);
                this.style.height = this._setValueUnit(this._height);
                this._updateScrollOverflow();
                break;
        }
    }
    
    _calcScale() {
        const scY = +this._msWin.height;
        const scX = +this._msWin.width;
        const containerW = this.clientWidth || +this._width;
        const containerH = this.clientHeight || +this._height;
        const scaleY = containerH / scY;
        const scaleX = containerW / scX;
        const winStyle = this._msWin.style;

        const scaleAspectWindow = scX / scY;
        const scaleAspectContainer = containerW / containerH;

        this._msWin._frameScaling = true;
    
        switch (this._msWin.proportiontype) {
            case 0:
                winStyle.transform = `scale(${scaleX}, ${scaleY})`;
                winStyle.transformOrigin = "0 0";
                break;
    
            case 1:
                winStyle.transform = `scale(${scaleX})`;
                winStyle.transformOrigin = "0 0";
                break;
    
            case 2:
                winStyle.transform = `scale(${scaleY})`;
                winStyle.transformOrigin = "0 0";
                break;
    
            case 3:
                if (scaleAspectWindow < scaleAspectContainer) {
                    winStyle.transform = `scale(${scaleX})`;
                } else {
                    winStyle.transform = `scale(${scaleY})`;
                }
                winStyle.transformOrigin = "0 0";
                break;
    
            case 4:
                if (scaleAspectWindow < scaleAspectContainer) {
                    winStyle.transform = `scale(${scaleY})`; 
                } else {
                    winStyle.transform = `scale(${scaleX})`;
                }
                winStyle.transformOrigin = "0 0";
                break;
    
            default:
                winStyle.transform = "";
                winStyle.transformOrigin = "";
        }
    }

    openWindow(obj, force, historyAction, disableSaveState) {
        if (!disableSaveState && toBool(this.getAttribute("saveWindowState"))) {
            this.saveItemState({
                windowState: {
                    windowId: obj.id,
                    objectid: obj.objectid,
                    taskid: obj.taskid,
                    outerpath: obj.outerpath,
                },
            });
        }

        const isWindowEqual = (this._msWin && this._msWin.id === obj.id)
            && (obj.objectid == this._msWin.getAttribute("objectid"))
            && (obj.outerpath == this._msWin.getAttribute("outerpath"));
        if (isWindowEqual) {
            return this._msWin;
        }
        if (!force && this._pushState) {
            history.pushState({ obj }, obj.id, window.location.search);
        }

        //если это не переход по истории (а открытие окна командой)
        if (!historyAction) {
            if (this.historyIdx == undefined) {
                this.historyIdx = 0;
            } else {
                this.historyIdx++;
                this.frameHistory = this.frameHistory.slice(0, this.historyIdx);
            }

            this.frameHistory.push({ Obj: obj });
        }

        this._clearWin();
        let param = "";
        const keys = Object.keys(obj);
        keys.forEach(key => {
            if (key !== "windowTriggers") {
                let paramVal = obj[key];
                if (typeof paramVal === "object")
                    paramVal = JSON.stringify(paramVal);
                param += ` ${key}='${paramVal}'`;
            }
        });

        const win = `<ms-window${param}></ms-window>`;

        let openingWindows = null;
        if ($sw.OpeningWindows == null) {
            openingWindows = [];
            $sw.OpeningWindows = openingWindows;
        }
        try
        {
            this.innerHTML = win;
        }
        catch (err) 
        {
           $ns.add({
                    type: "warning",
                    time: new Date().toLocaleString(),
                    title: i18next.t('open_win_error') + obj.id,
                    text: err
                });
        }
        if (openingWindows != null) {
            $sw.OpeningWindows = null;
            if (openingWindows)
                $sw.ItemSubscription.AddWindows(openingWindows);
        }

        this._msWin = this.querySelector("ms-window");
        if (obj["windowTriggers"] && !this._msWin.windowTriggers) {
            //TODO
            this._msWin.windowTriggers = JSON.parse(
                JSON.stringify(obj.windowTriggers)
            );
        }
        this._msWin.closeWin = this._clearWin.bind(this);
        if (!this.firstRun) {
            this.afterInitialize();
        }
        this.updateZ(); // окно может быть добавлено только через некоторое время, после того, как появится iframe,
        // и к этому моменту z-index будет равен 0. Поэтому нужно обновлять z-index
        return this._msWin;
    }

    _hasPdfExtension(url) {
        return url.match(/\.pdf$/i);
    }

    _hasHtmlExtension(url) {
        return url.match(/\.html$/i);
    }

    _clearWin() {
        const hasRoot =
            this.parentElement && this.parentElement.hasAttribute("root");
        if (!hasRoot) {
            while (this.firstChild) {
                //this.removeChild(this.firstChild);
                this.firstChild.remove();
            }
            if (this._msWin) {
                this._msWin.remove();
                this._msWin = null;
            }
        }
    }

    afterInitialize() {
        if (this.firstRun) {
            const { windowId, objectid, taskid, outerpath } =
                this.getStoredWindowState() || {};
            if (windowId) {
                const windDef = $WinDefs.winDef[windowId];
                this.openWindow({
                    ...windDef,
                    ...(objectid ? { objectid } : {}),
                    ...(taskid ? { taskid } : {}),
                    ...(outerpath ? { outerpath } : {}),
                });
                this.updateZ();
            }
        }

        for (let i = 0; i < this.children.length; i++) {
            if (this.children[i].afterInitialize)
                this.children[i].afterInitialize();
        }
        this.firstRun = false;
        this._calcSize();
    }

    getStoredWindowState() {
        if (toBool(this.getAttribute("saveWindowState"))) {
            return $ss.getItemState(this.getOriginPath())?.windowState;
        }
    }

    NextPage() {
        if (this.historyIdx != this.frameHistory.length - 1) {
            this.historyIdx++;
            const val = this.frameHistory[this.historyIdx];
            if (val.Addr) {
                this.setDs(val.Addr, true);
            } else {
                this.openWindow(val.Obj, true, true);
            }
        }
    }

    PreviousPage() {
        if (this.historyIdx != 0) {
            this.historyIdx--;
            const val = this.frameHistory[this.historyIdx];
            if (val.Addr) {
                this.setDs(val.Addr, true);
            } else {
                this.openWindow(val.Obj, true, true);
            }
        }
    }

    disconnectedCallback() {
        window.removeEventListener("ms_message", this.afterSwitch);
        this.removeEventListener('mouseenter', this._onMouseEnter);
        this.removeEventListener('mouseleave', this._onMouseLeave);
        this.removeEventListener('wheel', this._onWheel , { passive: false })
        window.removeEventListener('keydown', this._onKeyDown , true)
        super.disconnectedCallback();
    }
}